import * as React from 'react'
import { styles } from './styles.css'

type Props = {
  children?: React.ReactNode
}

export const PageHeading: React.FC<Props> = ({ children }) => {
  return <h1 className={styles.heading}>{children}</h1>
}
